import { render } from "./ProjectEditIframe.vue?vue&type=template&id=3cbfe5d8&ts=true"
import script from "./ProjectEditIframe.ts?vue&type=script&lang=ts&external"
export * from "./ProjectEditIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__